import React from "react"
import styled from "styled-components"
import media from "assets/styles/media"
import Banner from "components/uIElements/Banner"
import { ReactComponent as RRELogoSVG } from "assets/images/global/logoFull.svg"
import BGGrid, { LineConfig } from "./BGGrid"
import StickyTarget from "utils/StickyTarget"

type props = {}

const ContainedBanner: React.FC<props> = () => {
  const lineConfig: LineConfig = {
    sectionHeight: "100%",
    animationClass: "banner",
    behind: true,
  }

  return (
    <Wrapper data-scroll data-scroll-section>
      <StickyTarget id="We__Invest-hero" />
      <BGGrid lineConfig={lineConfig} />
      <BannerTrigger id="RRE_Banner" />
      <Banner left>
        <RRELogo data-scroll />
        RRE Ventures
      </Banner>
    </Wrapper>
  )
}

const BannerTrigger = styled.div`
  width: 100%;
  height: 0;
  bottom: 13.89vw;
  position: absolute;
`

const RRELogo = styled(RRELogoSVG)`
  width: 20.76vw;
  height: 8.26vw;
  margin: 0 3.47vw;
  ${media.mobile} {
    width: 53.232vw;
    height: 21.536vw;
  }
`

const Wrapper = styled.div`
  position: relative;
  z-index: 2;
`

export default ContainedBanner
